import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ role }) => {
    const location = useLocation();
    const usersId = localStorage.getItem("usersId");
    const usersAccess = localStorage.getItem("usersAccess");
    const adminId = localStorage.getItem("token"); // (if you store admin credentials)

    if (role === "user") {
        if (usersId && usersAccess) {
            return <Outlet />; // allow user routes
        } else {
            return <Navigate to="/user/login" state={{ from: location }} replace />;
        }
    }

    if (role === "admin") {
        if (adminId) {
            return <Outlet />; // allow admin routes
        } else {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
    }

    return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
